export enum HeadersName {
    ApiKey = 'x-api-key',
    CsrfProtection = 'X-HEADLESS-CSRF-PROTECTION',
    ShopperToken = 'x-shopper-token',
    SetCookie = 'Set-Cookie',
    Host = 'Host',
    Origin = 'Origin',
    ForwardedHost = 'X-Forwarded-Host',
    ForwardedProto = 'X-Forwarded-Proto',
    UserAgent = 'User-Agent',
    TraceId = 'x-trace-id',
    CacheControl = 'Cache-Control',
    Pragma = 'Pragma',
    SecretKey = 'x-secret-key',
    InstanceId = 'x-instance-id',
    Reco = 'x-reco', // AKAMAI: Recommendation type : T2S or Potion
    NextIntlLocale = 'x-next-intl-locale',
}

export type HeadersRecord = Partial<Record<HeadersName, string>>;
